<template>
  <div class="content">
    <!--列表-->
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>线索列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row type="flex">
        <!-- <el-col :span="3">
          <el-input
            v-model="where.series_name"
            style="width: 200px"
            placeholder="车系名称"
            clearable
            size="mini"
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="where.brand_name"
            style="width: 200px"
            placeholder="品牌名称"
            clearable
            size="mini"
          ></el-input>
        </el-col>
        <el-button type="primary" @click="index(where)" size="mini">查询</el-button> -->
        <el-button type="primary" size="mini" @click="isExcel">导出EXCEL</el-button>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-table
          v-loading="loading"
          border
          :data="tableData"
          height="650"
          style="margin-bottom: 5px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="get_models.model_name"
            label="车型"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_models.series_name"
            label="车系"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_models.brand_name"
            label="品牌名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="get_dealers.province"
            label="省份"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="get_dealers.city" label="城市" align="center">
            <template slot-scope="scope">
              {{ (scope.row.get_dealers?scope.row.get_dealers.city:"")}}
            </template>
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            align="center"
          >
          </el-table-column>
           <el-table-column prop="created_at" align="center" label="名称">
            <template slot-scope="scope">
              {{ (scope.row.get_dealers?scope.row.get_dealers.city:"") + (scope.row.get_models?scope.row.get_models.brand_name:"")}}
            </template>
          </el-table-column>
          <el-table-column prop="created_at" align="center" label="报名时间">
            <template slot-scope="scope">
              {{ $utils.isDate(scope.row.created_at) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            align="center"
            label="操作"
            width="250"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                v-if="$utils.checkPer('car-user-sign.store')"
                @click="delMessage(scope.row)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="index(where)"
          :current-page.sync="where.page"
          :page-size="where.pagesize"
          :page-sizes="[10, 100, 500, 1000, 5000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getuser,
  adduser,
  modifyuser,
  deluser
} from "../../api/api";
import xlsx from "xlsx";
export default {
  name: "car-user-sign",
  data() {
    return {
      tableData: [],
      keyword: [],
      loading: false,
      where: {
        sign: "1",
        source: "1",
        open_type: "",
        brand_name: "",
        series_name: "",
        page: 1,
        pagesize: 10,
      },
      total: 0,
      timeArr: [],
      multipleSelection: [],
      dialogVisible: false,
      form: {
        city: [],
        model: [],
      },
      options: [],
      optionsCar: [],
      props: { multiple: true, checkStrictly: true },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getuser(this.where).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        this.total = data.data.total;
        this.tableData = data.data.data;
        console.log(this.tableData);
        this.loading = false;
      });
    },
    handleChange(value) {
      this.form.city = value;
    },
    handleCar(val) {
      this.form.model = val;
    },
    crtyFun() {},
    addData() {
      this.dialogVisible = true;
    },
    editMessage(scope) {},
    delMessage(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deluser(row.id).then((msg) => {
            let { data } = msg;
            data = JSON.parse(data);
            if (data.code == 200) {
              this.$message.success(data.msg);
              this.getList();
            } else {
              this.$message.error(data.msg);
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.where.pagesize = val;
      this.getList();
    },
    index(e) {
      this.where.start_time = this.timeArr == null ? "" : this.timeArr[0];
      this.where.end_time = this.timeArr == null ? "" : this.timeArr[1];
      this.where = e;
      this.getList();
    },
    isExcel() {
      if(this.multipleSelection.length == 0){
        this.$message.error("请选中导出数据")
        return
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        let obj = {
          车型: item.get_models.model_name,
          车系: item.get_models.series_name,
          品牌名: (item.get_models?item.get_models.brand_name:""),
          省份: item.get_dealers?item.get_dealers.province:"",
          城市: (item.get_dealers?item.get_dealers.city:""),
          电话: item.mobile,
          名称: (item.get_dealers?item.get_dealers.city:"")+(item.get_models?item.get_models.brand_name:""),
          时间: item.created_at,
        };
        arr.push(obj);
      });
      let sheet = xlsx.utils.json_to_sheet(arr);
      let book = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(book, sheet, "数据表");
      xlsx.writeFile(book, `biubiu~~${new Date().getTime()}.xls`);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    allDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选中数据");
        return;
      }
      let str = "";
      for (let i = 0; i < this.multipleSelection.length; i++) {
        str += this.multipleSelection[i].id + ",";
      }
      str = str.substring(0, str.length - 1);
      delSet(str).then((msg) => {
        let { data } = msg;
        data = JSON.parse(data);
        if (data.code == 200) {
          this.$message.success(data.msg);
          this.getList();
        } else {
          this.$message.error(data.msg);
          this.getList();
        }
      });
    },
    handleClose() {},
  },
  filters: {
    getImg: function (value) {
      if (value == null || value == "[]") return "";
      let res = JSON.parse(value);
      let url = "";
      if (res[0].response)
        url = window.location.origin + "/" + res[0].response.path;
      return url;
    },
    getText: function (value) {
      if (!value || value == "") return "";
      let res_json = JSON.parse(value);
      let res = "";
      for (var i = 0; i < res_json.length; i++) {
        res += res_json[i] + "\n";
      }
      console.log(res);
      return res;
    },
    getHot: function (value) {
      //if (!value || value == '') return '';
      if (value) {
        return "是";
      } else {
        return "否";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.el-col-3 {
  width: 210px;
}
.el-col-1 {
  width: 68px;
}
.el-breadcrumb {
  margin-bottom: 15px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 350px;
  margin-left: 13px;
}
</style>
